// extracted by mini-css-extract-plugin
export var createdDate = "_ky-1";
export var divider = "_ky-2";
export var headerDivider = "_ky-3";
export var messagesCard = "_ky-0";
export var messagesContainer = "_ky-7";
export var messagesContainerWrapper = "_ky-4";
export var pointerCapturingButtonBoxes = "_ky-a";
export var showLeftPanelButton = "_ky-9";
export var showMoreButton = "_ky-c";
export var showMoreButtonContainer = "_ky-b";
export var summaryTitle = "_ky-6";
export var systemMessageCardWrapper = "_ky-d";
export var topButtons = "_ky-8";
export var withPadding = "_ky-5";